import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import * as Actions from '../redux/keywordActions';
import * as Selectors from '../redux/keywordSelectors';
import KeywordForm from '../form/KeywordForm';
import { KeywordValues } from '../model/keywordModel';
import { ROUTES } from '../../../core/router/routes';
import SnackbarSettings from '../../../components/Snackbar/SnackbarSettings';
import useMainProgressContext from '../../../components/progress/MainProgress/context/MainProgressContext';

const initialValues: KeywordValues = {
  name: '',
};

const breadcrumbs = [
  {
    label: 'keyword.add',
    to: null,
  },
];

const KeywordAdd: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const apiRequestState = useSelector(Selectors.apiKeywordRequestState);
  const apiRequestError = useSelector(Selectors.apiKeywordRequestError);
  const { show, hide } = useMainProgressContext();

  useEffect(() => {
    hide();
  }, []);

  return (
    <>
      <SnackbarSettings
        successMessage="keyword.snackbar.add_success"
        apiRequestState={apiRequestState}
        apiRequestError={apiRequestError}
        setApiRequestState={Actions.setApiKeywordRequestState}
        onSuccess={() => {
          history.push(ROUTES.KEYWORD.LIST);
        }}
      />
      <KeywordForm
        breadcrumbs={breadcrumbs}
        title="keyword.add"
        initialValues={initialValues}
        onSubmit={(values: KeywordValues) => {
          show();
          dispatch(Actions.addKeyword(values));
        }}
      />
    </>
  );
};

export default KeywordAdd;
